import ExecAPI from 'appRoot/api/api';

export function GetGraphiteAdminData()
{
	return ExecAPI("GraphiteAdminData/GetGraphiteAdminData");
}
export function SetGraphiteAdminData(json)
{
	return ExecAPI("GraphiteAdminData/SetGraphiteAdminData", { json });
}